module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/181.0aa482be.png";